import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PreAula } from 'src/app/models/pre-aula';
import { AulaVisualizacao } from 'src/app/models/aula-visualizacao';
import * as moment from 'moment';
import { QuestaoFlashCard } from 'src/app/models/questao-flash-card';
import { AvaliacaoAula } from 'src/app/models/avaliacao-aula';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AulaOndeParou } from 'src/app/models/aula-onde-parou';

@Injectable({
  providedIn: 'root',
})
export class AulaService {
  constructor(private http: HttpClient) {}

  getAulasCronograma(id: number, data: any) {
    data = moment(data).locale('pt-br').format('YYYY-MM-DD');
    return this.http.get<any[]>(`${environment.baseApiUrl}/aulas/${id}/cronogramas?data=${data}`);
  }

  getPreAula(id: number) {
    return this.http.get<PreAula>(`${environment.baseApiUrl}/aulas/pre-aula/${id}`);
  }

  getAulaVisualizacao(id: number) {
    return this.http.get<AulaVisualizacao>(`${environment.baseApiUrl}/aulas/${id}/visualizacao`);
  }

  inativarAulaVisualizacao(aulaId: number) {
    return this.http.post<AulaVisualizacao>(`${environment.baseApiUrl}/aulas/${aulaId}/visualizacao`, {});
  }

  salvarTempoOndeParou(planoId: number, aulaId: number, aula: AulaVisualizacao) {
    return this.http.post(`${environment.baseApiUrl}/aulas/${planoId}/${aulaId}/visualizacao/tempo`, aula).pipe(
      map((result: any) => {
        if (result) {
          return result;
        }
        return null;
      }),
      catchError((e) => throwError(e))
    );
  }

  getAulas(plano: number, modulo: number, subModulo?: number) {
    console.log(`${environment.baseApiUrl}/Aulas/${plano}/${modulo}/${subModulo}`);
    return this.http.get<any[]>(`${environment.baseApiUrl}/Aulas/${plano}/${modulo}/${subModulo}`, {
      observe: 'response',
    });
  }

  getQuestoesFlashCard(id: number) {
    return this.http.get<QuestaoFlashCard[]>(`${environment.baseApiUrl}/aulas/${id}/flashcard`);
  }

  getAvaliacao(id: number) {
    return this.http.get<AvaliacaoAula>(`${environment.baseApiUrl}/aulas/${id}/avaliacoes`);
  }

  salvarAvaliacao(id: number, avaliacaoAula: AvaliacaoAula) {
    return this.http.post<AvaliacaoAula>(`${environment.baseApiUrl}/aulas/${id}/avaliacoes`, avaliacaoAula);
  }

  getAulaOndeParou() {
    return this.http.get<AulaOndeParou>(`${environment.baseApiUrl}/aulas/ultima`);
  }
}
